import CryptoJS from 'crypto-js'

export const encryptToken = (token, key) => {
  const iv = CryptoJS.lib.WordArray.random(16)

  const encrypted = CryptoJS.AES.encrypt(token, key, { iv })

  const combined = iv.toString() + encrypted.toString()

  return combined
}

export const decryptToken = (encrypted, key) => {
  const iv = CryptoJS.enc.Hex.parse(encrypted.slice(0, 32))

  const encryptedToken = encrypted.slice(32)

  try {
    const decrypted = CryptoJS.AES.decrypt(encryptedToken, key, { iv })

    return decrypted.toString(CryptoJS.enc.Utf8)
  } catch (error) {
    console.error('Error durante la desencriptación:', error)
    return null
  }
}

export const encryptData = (data, key) => {
  const iv = CryptoJS.lib.WordArray.random(16)

  const encrypted = CryptoJS.AES.encrypt(data, CryptoJS.enc.Hex.parse(key), {
    iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  })

  const encryptedData = iv.concat(encrypted.ciphertext).toString(CryptoJS.enc.Hex)

  return encryptedData
}

export const decryptSecretKey = (secretKey, encryptionKey) => {
  if (!encryptionKey || encryptionKey.length !== 64) {
    throw new Error('ERROR_AUTH.INVALID_KEY')
  }

  try {
    const ivHex = secretKey.slice(0, 32)
    const encryptedDataHex = secretKey.slice(32)

    const iv = CryptoJS.enc.Hex.parse(ivHex)
    const encryptedData = CryptoJS.enc.Hex.parse(encryptedDataHex)

    const key = CryptoJS.enc.Hex.parse(encryptionKey)

    const decrypted = CryptoJS.AES.decrypt(
      { ciphertext: encryptedData },
      key,
      { iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 }
    )

    return CryptoJS.enc.Utf8.stringify(decrypted)
  } catch (error) {
    throw new Error('ERROR_AUTH.INVALID_KEY')
  }
}

export const encryptSecretKey = (data, encryptionKey) => {
  if (!encryptionKey || encryptionKey.length !== 64) {
    throw new Error('ERROR_AUTH.INVALID_KEY')
  }

  const iv = CryptoJS.lib.WordArray.random(16)

  const key = CryptoJS.enc.Hex.parse(encryptionKey)

  const encrypted = CryptoJS.AES.encrypt(data, key, {
    iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  })

  const ivHex = iv.toString(CryptoJS.enc.Hex)
  const encryptedDataHex = encrypted.ciphertext.toString(CryptoJS.enc.Hex)

  return ivHex + encryptedDataHex
}
